"use client"

import styled from "@emotion/styled"
import Box from "@mui/material/Box"
import React from "react"

interface FilteredItemWrapperProps {
  children: React.ReactNode
  className?: string
}

const StyledFilteredItemWrapper = styled(Box)`
  display: flex;
  width: 100%;
  justify-content: center;
`

const FilteredItemWrapper: React.FC<FilteredItemWrapperProps> = ({
  children,
  className,
}) => {
  return (
    <StyledFilteredItemWrapper className={className}>
      {children}
    </StyledFilteredItemWrapper>
  )
}

export default FilteredItemWrapper
